import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import nationalities from 'i18n-nationality';
import enLocale from 'i18n-nationality/langs/en.json';

import ReactSelectField from './ReactSelectField';

nationalities.registerLocale(enLocale);

const NationalitySelector = ({ name }) => {
  const options = useMemo(
    () =>
      Object.entries(nationalities.getNames('en')).map(
        ([countryCode, nationality]) => ({
          value: countryCode,
          label: nationality,
        }),
      ),
    [],
  );

  return <ReactSelectField name={name} options={options} isMulti />;
};

NationalitySelector.propTypes = {
  name: PropTypes.string,
};

export default NationalitySelector;
